import { injectable } from 'inversify';
import { ConfigServiceContract, Config } from '@/core/contracts';
import { getBaseUrl, makeRequest } from '../helpers/utils';
import config from '@/config';

/**
 * Server settings for client.
 * @export
 * @class ConfigService
 * @implements {ConfigServiceContract}
 */
@injectable()
export class ConfigService implements ConfigServiceContract {
    private _config: Config = {};

    constructor() {
        /* empty constructor*/
    }

    public async startupAsync(): Promise<void> {
        const response = await fetch(
            `${config.remoteHost}${config.fetch.apiPrefix}/services`
        );
        const configServices = await response.json();
        const applicationHost = getBaseUrl();

        this._config.Services = configServices;

        this._config.Auth = {
            authority: `${configServices.identityURL}/`,
            client_id: 'js',
            response_type: 'id_token token',
            scope: 'openid profile api',
            filterProtocolClaims: true,
            loadUserInfo: true,
            automaticSilentRenew: true,
            revokeAccessTokenOnSignout: true,
            redirect_uri: `${applicationHost}auth-callback`,
            silent_redirect_uri: `${applicationHost}silent-callback`,
            post_logout_redirect_uri: `${applicationHost}`
        };
    }

    public getConfig(): Config {
        return this._config;
    }
}
